import { Row } from 'antd'
import DamagesTitle from 'app/components/Core/DamageItem/DamagesTitle'
import Table from 'app/components/Core/DamageItem/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useQuery } from 'app/lib/hooks/useQuery'
import { PageProps } from 'app/pages/typing'
import { FETCH_RENTAL_FOR_DAMAGES } from 'app/queries/Rentals'
import * as React from 'react'
import { useParams } from 'react-router-dom'

const Damage: React.FC<PageProps> = () => {
  const { rental_id } = useParams<{ rental_id: string }>()
  const { data, loading } = useQuery<{ rental: IRental }>(FETCH_RENTAL_FOR_DAMAGES, {
    variables: { id: rental_id },
    fetchPolicy: 'cache-first'
  })

  return (
    <Row gutter={[0, 12]}>
      <KCol card span={24} loading={loading}>
        <DamagesTitle member={data?.rental} />
        <Table params={{ filters: { rental_ids: [rental_id] } }} />
      </KCol>
    </Row>
  )
}

export default Damage
